// extracted by mini-css-extract-plugin
export var searchHeader = "_2n-0";
export var searchHeaderDark = "_2n-1";